import LevelUp from './LevelUp';

export default LevelUp;
